import { motion } from "motion/react";

export function SineWaveBackground() {
  // Generate multiple waves with different properties
  const waves = Array.from({ length: 12 }).map((_, i) => ({
    id: i,
    delay: -i * 2,
    duration: 20 + Math.random() * 20,
    yOffset: 300 + Math.random() * 200, // Vertical position variation
    amplitude: 40 + Math.random() * 60, // Wave height
    opacity: 0.1 + Math.random() * 0.2, // Subtle opacity
    color: i % 3 === 0 ? "#FD5750" : i % 3 === 1 ? "#3B82F6" : "#cbd5e1", // Brand red, Blue, Slate
    direction: i % 2 === 0 ? 1 : -1, // Some move left, some move right
  }));

  return (
    <div className="absolute inset-0 z-0 overflow-hidden pointer-events-none select-none">
      <svg
        className="w-full h-full"
        viewBox="0 0 1440 800"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid slice"
      >
        <defs>
          <linearGradient id="wave-grad-red" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#FD5750" stopOpacity="0" />
            <stop offset="50%" stopColor="#FD5750" stopOpacity="0.4" />
            <stop offset="100%" stopColor="#FD5750" stopOpacity="0" />
          </linearGradient>
          <linearGradient id="wave-grad-blue" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#3B82F6" stopOpacity="0" />
            <stop offset="50%" stopColor="#3B82F6" stopOpacity="0.3" />
            <stop offset="100%" stopColor="#3B82F6" stopOpacity="0" />
          </linearGradient>
           <linearGradient id="wave-grad-slate" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#64748b" stopOpacity="0" />
            <stop offset="50%" stopColor="#64748b" stopOpacity="0.2" />
            <stop offset="100%" stopColor="#64748b" stopOpacity="0" />
          </linearGradient>
        </defs>

        {waves.map((wave) => {
           const pathD = `M-1440 ${wave.yOffset} Q -1080 ${wave.yOffset - wave.amplitude} -720 ${wave.yOffset} T 0 ${wave.yOffset} T 720 ${wave.yOffset} T 1440 ${wave.yOffset} T 2160 ${wave.yOffset}`;
           
           return (
            <motion.path
              key={wave.id}
              d={pathD}
              stroke={
                  wave.color === "#FD5750" ? "url(#wave-grad-red)" : 
                  wave.color === "#3B82F6" ? "url(#wave-grad-blue)" : 
                  "url(#wave-grad-slate)"
              }
              strokeWidth={1.5}
              fill="none"
              initial={{ x: wave.direction === 1 ? 0 : -1440 }}
              animate={{ x: wave.direction === 1 ? -1440 : 0 }}
              transition={{ 
                  duration: wave.duration, 
                  repeat: Infinity, 
                  ease: "linear",
                  delay: wave.delay 
              }}
              style={{ opacity: wave.opacity }}
            />
          );
        })}
      </svg>
    </div>
  );
}
